import MagicWand from '@components/icons/MagicWand.svg';
import { ModalNamesEnum } from 'app/types/enums/ModalNamesEnum';
import { useModalContext } from '@providers/ModalProvider';
import { usePageContext } from '../../../../../../providers/PageProvider';
import { AdminJobTopActionButton } from '@components/core-ui/form-elements/buttons/Button/variations/AdminJobTopActionButton';

export const ApplyEnhancementButton = () => {
  const { job, manualReload } = usePageContext();
  const { openModal, closeModal } = useModalContext();

  if (!job?.media?.length) {
    return null;
  }

  const buttonLabel = job?.enhancedCharged ? 'Reapply AI Enhancement' : 'Apply AI Enhancement';
  const isReapply = !!job?.enhancedCharged;

  const handleEnhancement = () => {
    openModal(ModalNamesEnum.AdminApplyEnhancementModal, {
      jobId: job.id,
      isReapply,
      onSuccess: () => {
        closeModal();
        manualReload();
      },
    });
  };

  return (
    <AdminJobTopActionButton title={buttonLabel} onClick={handleEnhancement} className="min-w-[170px]">
      <MagicWand />
      {buttonLabel}
    </AdminJobTopActionButton>
  );
};
